import React from 'react'
import {Container, Row, Col, Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const FlightInternationSkeleton = () => {
  return (
    <Container
      className="refendable11 refendable11onword"

      // style={{maxWidth:"100%"}}
    >
      <Row className="price1">
        <Col
          className="price111 price111onword"
          style={{ paddingInline: "5px" }}
        >
          <Row className="flight11" flight="UL">
            <Col className="flight112" flightcraft="">
              <div className="stopscount" stop="1">
                <div className="Price33827 allshow block-content-2 custom_block_content flight-list-v2 ULSri Lankan Airlines 0Stops bingo_button_4">
                  <div className="box-result custom_box_result">
                    <div className="inter_trip_left">
                      <h4>
                        {" "}
                        <Skeleton />
                      </h4>
                      {/* {e.Segments[0].map((returnflight, index2) => ( */}
                      <ul
                        className="list-search-result result_list"
                        style={{ display: "flex" }}
                      >
                        <li>
                          <Skeleton />
                          <div className="flight_name obflight_name">
                            <Skeleton />{" "}
                            <span className="flight_no">
                              <Skeleton />
                            </span>
                          </div>
                        </li>
                        <li className="depart_time cus_dep_arr_time">
                          <span className="date departdate">
                            <Skeleton />
                            <Skeleton />
                          </span>
                          {/* {e.Segments[0][0].Origin.Airport.CityName} */}
                          <div className="date_time">
                            <Skeleton />
                          </div>
                        </li>
                        <li className="flight_time_between">
                          <span className="duration departdur">
                            {/* {e.AirSegments[0][0].Duration} */}
                            <Skeleton />|
                            <div className="cus_tooltip">
                              {/* {e.Segments[0].length - 1 == 0
                                    ? "Non-Stop"
                                    : `${e.Segments[0].length - 1} Stops`}{" "} */}
                              <span className="tooltiptext">
                                {/* {e.Segments[0]
                                      .map(
                                        (segment, index) =>
                                          segment.Origin.Airport.CityCode
                                      )
                                      .join("→")}
                                    →
                                    {
                                      e.Segments[0][e.Segments[0].length - 1]
                                        .Destination.Airport.CityCode
                                    } */}
                              </span>
                            </div>
                          </span>
                          <div className="time_separete"></div>
                          <div className="flight_rel">
                            {" "}
                            {/* {e.Segments[0]
                                  .map(
                                    (segment, index) =>
                                      segment.Origin.Airport.CityCode
                                  )
                                  .join("→")}
                                →
                                {
                                  e.Segments[0][e.Segments[0].length - 1]
                                    .Destination.Airport.CityCode
                                } */}
                          </div>
                        </li>
                        <li className="arrive_time cus_dep_arr_time">
                          <span className="date arivedate">
                            <Skeleton />
                            <Skeleton />
                          </span>
                          {
                            // e.Segments[0][e.Segments[0].length - 1]
                            //   .Destination.Airport.CityName
                          }
                          <div className="date_time">
                            <Skeleton />
                          </div>
                        </li>
                      </ul>
                      {/* ))} */}
                      <div className="clearfix"></div>
                      <div className="hr_seperator"></div>
                      <h4>
                        <Skeleton />
                      </h4>
                      {/* {e.Segments[1].map((returnflight, index2) => ( */}
                      <ul
                        className="list-search-result result_list"
                        style={{ display: "flex" }}
                      >
                        <li>
                          <Skeleton />
                          <div className="flight_name">
                            <Skeleton />
                            <span className="flight_no">
                              <Skeleton />
                            </span>
                          </div>
                        </li>
                        <li className="depart_time cus_dep_arr_time">
                          <span className="date">
                            {" "}
                            <Skeleton />
                            <Skeleton />
                          </span>
                          {/* {e.Segments[1][0].Origin.Airport.CityName} */}
                          <div className="date_time cus_dep_arr_time">
                            <Skeleton />
                          </div>
                        </li>
                        <li className="flight_time_between">
                          <span className="duration">
                            {/* {e.AirSegments[1][0].Duration}  */}
                            <Skeleton />|
                            <div className="cus_tooltip">
                              {/* {e.Segments[1].length - 1 == 0
                                    ? "Non-Stop"
                                    : `${e.Segments[1].length - 1} Stops`}{" "} */}
                            </div>
                          </span>
                          <div className="time_separete"></div>
                          <div className="flight_rel">
                            {" "}
                            {/* {e.Segments[1]
                                  .map(
                                    (segment, index) =>
                                      segment.Origin.Airport.CityCode
                                  )
                                  .join("→")}
                                →
                                {
                                  e.Segments[1][e.Segments[1].length - 1]
                                    .Destination.Airport.CityCode
                                } */}
                          </div>
                        </li>
                        <li className="arrive_time cus_dep_arr_time">
                          <span className="date">
                            <Skeleton />
                            <Skeleton />
                          </span>
                          {
                            // e.Segments[1][e.Segments[1].length - 1]
                            // .Destination.Airport.CityName
                          }
                          <div className="date_time">
                            <Skeleton />
                          </div>
                        </li>
                      </ul>
                      {/* ))} */}
                    </div>
                    <div className="book_flight">
                      <div className="refundable clr_green">
                        {/* <span>
                          <Skeleton />
                        </span> */}
                      </div>
                      <p style={{ fontSize: "12px", fontWeight: "500" }}>
                        {/* <div className="light_one_way blink"></div> */}
                         <Skeleton />
                      </p>
                      <span className="fli_price airlineprice">
                        <span style={{ fontSize: "12px", color: "#000" }}>
                          <Skeleton />
                        </span>{" "}
                        &nbsp;
                        <span className="mainprice">
                          <Skeleton />
                        </span>
                        <br />
                        <span
                          style={{
                            marginTop: "5px",
                            marginBottom: "3px",
                            fontSize: "13px",
                            color: "#000",
                          }}
                        >
                          <Skeleton />
                        </span>
                      </span>
                      <div className="bookbtn_morefare">
                        <div className="book_btn">
                            <Skeleton />
                        </div>
                        <div className="more_farebtn"></div>
                      </div>
                    </div>

                    <div className="clearfix"></div>
                    <div className="flight_details">
                      <div className="main_flight_btn">
                        <a className="details_btn flightdetailajax">
                          <Skeleton />
                        </a>
                      </div>
                      {/* <div
                          className="flight_details_info"
                          is_show="0"
                          id="show_UL196UL225UL226UL195"
                        >
                          <h4>Please wait loading...</h4>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default FlightInternationSkeleton
